import styled, { css } from 'styled-components'
import { rem } from 'polished'
import zIndex from 'styles/tools/z-index'

export const STICKY_DATE_COL_WIDTH = rem(300)
export const FARE_COL_MIN_WIDTH = rem(180)

export const verticalCellDivider = css`
  border-inline-end: 1px solid ${p => p.theme.palette.neutral.surface.lightForeground};
`
export const stickyDateColumn = css`
  position: sticky;
  inset-inline-start: 0;
  width: ${STICKY_DATE_COL_WIDTH};
  min-width: ${STICKY_DATE_COL_WIDTH};
  max-width: ${STICKY_DATE_COL_WIDTH};
  vertical-align: middle;
`

export const ExpandedSectionStickyTd = styled.td<{ $isLastExpandedRow: boolean }>`
  ${stickyDateColumn}
  z-index: ${zIndex.offerFilters};
  padding: ${rem(16)} ${rem(12)};
  background-color: ${p => p.theme.palette.neutral.surface.lightBackground};
  ${verticalCellDivider}
  border-top: 1px solid ${p => p.theme.palette.neutral.surface.lightForeground};
  ${p => p.$isLastExpandedRow && css`border-end-start-radius: ${p.theme.borderRadius.S};`}
  vertical-align: top;
`
export const ExpandedSectionFareTd = styled.td<{ $isLastFareColumn: boolean; $isLastExpandedRow: boolean }>`
  min-width: ${FARE_COL_MIN_WIDTH};
  padding: 0;
  background-color: ${p => p.theme.palette.neutral.surface.normalBackground};
  border-top: 1px solid ${p => p.theme.palette.neutral.surface.lightForeground};
  ${p => !p.$isLastFareColumn && verticalCellDivider}
  ${p => p.$isLastFareColumn && css`
    ${p.$isLastExpandedRow && css`border-end-end-radius: ${p.theme.borderRadius.S};`}
  `}
  vertical-align: top;
`
